import jQuery from 'jquery';

jQuery($ => {
	$('.show-hidden').on('click', function () {
		$($(this).attr('data-target')).fadeIn();
		$(this).hide();
	});
})
